@if (suppliers(); as suppliers) {
  <div
    class="input-supplier"
    [hidden]="showMode()"
  >
    <mat-form-field
      floatLabel="always"
      appearance="outline"
      subscriptSizing="dynamic"
    >
      @if (label()) {
        <mat-label class="input-supplier__label">
          @if (hint()) {
            <mat-icon
              class="input-supplier__hint"
              [matTooltip]="hint()"
            >
              info
            </mat-icon>
          }
          <div class="input-supplier__label-text">
            {{ label() }}
          </div>
          @if (isRequired && !showMode()) {
            <span class="input-required"> * </span>
          }
        </mat-label>
      }
      <ng-select
        #supplierSelect
        class="input-supplier__select autosize"
        ngSelectMat
        clearAllText="Clear selection"
        [formControl]="control()"
        [items]="suppliers"
        [groupBy]="groupBy()"
        [loading]="isLoading()"
        [typeahead]="typeahead$"
        [bindLabel]="bindLabel()"
        [compareWith]="suppliersCompare"
        [placeholder]="placeholder()"
        [notFoundText]="emptyState"
        [multiple]="multiple()"
        [clearable]="clearable()"
        [appendTo]="appendTo()"
        [id]="id() ?? ''"
      >
        <ng-template
          let-item="item"
          ng-label-tmp
        >
          <div class="ng-value-label">
            {{ item.name }}
          </div>
        </ng-template>
        <ng-template
          let-items="items"
          let-clear="clear"
          ng-multi-label-tmp
        >
          @for (item of items; track item.id) {
            <div class="ng-value">
              <div class="ng-value-label">
                {{ item.name }}
              </div>
              <div
                class="ng-value-icon right"
                aria-hidden="true"
                (click)="clear(item)"
              >
                x
              </div>
            </div>
          }
        </ng-template>
        <ng-template
          let-item="item"
          ng-option-tmp
        >
          <div>
            {{ item.name }}
          </div>
          <span class="input-supplier__info">
            @if (item.existsInSap === false) {
              <span class="input-supplier__info__sap">
                <mat-icon class="input-supplier__warning">warning</mat-icon>
                DETACHED |
              </span>
            }
            @if (item.smVendorId) {
              <span class="input-supplier__info__id"> {{ item.smVendorId }} | </span>
            }
            @if (item.guid) {
              <span class="input-supplier__info__id"> {{ item.guid }} | </span>
            }
            {{ [item.address, item.city, item.country?.getDisplay()] | join: " / " }}
          </span>
        </ng-template>
        @if ((searchValue || !mdfId()) && suppliers?.length !== dataSourceTotalLength) {
          <ng-template ng-footer-tmp>
            <div class="ng-footer">
              <div class="ng-footer__info">
                Showing {{ (pageIndex - 1) * pageSize + 1 }} to
                {{ (pageIndex - 1) * pageSize + (suppliers.length || 0) }} of {{ dataSourceTotalLength }} entries
              </div>
              <button
                procure-button
                variant="ghost"
                [disabled]="pageIndex === 1"
                (click)="changePage('prev')"
              >
                <mat-icon>chevron_left</mat-icon>
              </button>
              <button
                procure-button
                variant="ghost"
                [disabled]="pageIndex * pageSize > dataSourceTotalLength"
                (click)="changePage('next')"
              >
                <mat-icon>chevron_right</mat-icon>
              </button>
            </div>
          </ng-template>
        }
      </ng-select>
    </mat-form-field>
  </div>
  <procure-show-field
    [hidden]="!showMode()"
    [label]="label()"
    [hint]="hint()"
  >
    {{ value || "-" }}
  </procure-show-field>
}
